module.exports = __webpack_public_path__ + "static/img/2.0bcce3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myprize/2.png
// module id = y3qs
// module chunks = 1